import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type QuizTranslations = {
  [lang: string]: Translation;
};

export const quizTranslations: QuizTranslations = {
  en,
};
